import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { first, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { CoreConfigService } from '@core/services/config.service';
import { ActivatedRoute, Router } from '@angular/router';
import { statusCode } from 'app/auth/models/commonEnum';
import Swal from 'sweetalert2';
import { AuthenticationService } from 'app/auth/service';
import * as CryptoJS from 'crypto-js';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ResetPasswordComponent implements OnInit {
	// Public
	public coreConfig: any;
	public passwordTextType: boolean;
	public confPasswordTextType: boolean;
	public resetPasswordForm: FormGroup;
	public submitted = false;
	public ID: string;
	public EMAIL : any;
	public key = environment.cryptoJSKey;
	public iv = environment.cryptoJSIV;
	// Private
	private _unsubscribeAll: Subject<any>;
	public loading: boolean;
	public error: any;
	public decryptedEmail : String;
	/**
	 * Constructor
	 *
	 * @param {CoreConfigService} _coreConfigService
	 * @param {FormBuilder} _formBuilder
	 */
  	constructor(private _coreConfigService: CoreConfigService, 
				private route: ActivatedRoute,
				private _formBuilder: FormBuilder,
				private _authenticationService: AuthenticationService,
				private _router: Router) {
				this.route.params.subscribe(parmas => {
					this.ID = parmas["id"];
				});
				this.route.params.subscribe(parmas => {
					this.EMAIL = parmas["email"];
				});
				
				this._unsubscribeAll = new Subject();
				console.log(this.EMAIL);
				// Configure the layout
				this._coreConfigService.config = {
					layout: {
						navbar: {
						hidden: true
						},
						menu: {
						hidden: true
						},
						footer: {
						hidden: true
						},
						customizer: false,
						enableLocalStorage: false
					}
				};
	}

	// convenience getter for easy access to form fields
	get f() {
		return this.resetPasswordForm.controls;
	}

	/**
	 * Toggle password
	 */
	togglePasswordTextType() {
		this.passwordTextType = !this.passwordTextType;
	}

	/**
	 * Toggle confirm password
	 */
	toggleConfPasswordTextType() {
		this.confPasswordTextType = !this.confPasswordTextType;
	}

	/**
	 * On Submit
	 */
	onSubmit() {
		this.submitted = true;
		// stop here if form is invalid
		if (this.resetPasswordForm.invalid) {
			return false;
		}
		
		const encryptedPassword = CryptoJS.HmacSHA256(this.resetPasswordForm.get('newPassword').value, this.key).toString();
		const data = {
			customerId : this.ID,
			newPassword: encryptedPassword,
		}
		this.loading = true;
		this._authenticationService.updatePassword(data).pipe(first())
			.subscribe(
				result => {
					console.log(result);
					if (Number(result["statusCode"]) === statusCode.SUCCESS) {
						this.submitted = false;
						Swal.fire({
							icon: 'success',
							title: 'Congratulations!',
							text: result.message,
							customClass: {
								confirmButton: 'btn btn-success'
							}
						});
						this._router.navigate(['/login']);
					}
					else {
						this.error = result.message;
						this.loading = false;
						Swal.fire({
							icon: 'info',
							title: 'Info!',
							text: result["message"],
							customClass: {
								confirmButton: 'btn btn-error'
							}
						});
					}
				},
				error => {
					this.error = error;
					this.loading = false;
					Swal.fire({
						icon: 'error',
						title: 'Error!',
						text: error,
						customClass: {
							confirmButton: 'btn btn-error'
						}
					});
				}
			);
		
		return false;
	}

	// Lifecycle Hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {
		// Subscribe to config changes
		this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
		this.coreConfig = config;
		});
		
		if(this.EMAIL != undefined){
			var decEmail = CryptoJS.AES.decrypt(this.EMAIL, this.key,
			{
				keySize: 128 / 8,
				ivs: this.iv,
				mode: CryptoJS.mode.CBC,
				padding: CryptoJS.pad.Pkcs7
			});
			this.decryptedEmail = decEmail.toString(CryptoJS.enc.Utf8);
		}
		this.resetPasswordForm = this._formBuilder.group({
			newPassword: ['', [Validators.required]],
			confirmPassword: ['', [Validators.required]],
			email :[this.decryptedEmail]
		});
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}
}
